import {
  ADD_NOTE,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_CLEAN,
  ADD_NOTE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  note: {},
}

const NoteAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTE:
      state = {
        ...state,
        loading: true,
        error: "",
      }
      break
    case ADD_NOTE_SUCCESS:
      state = {
        ...state,
        note: action.payload.note,
        loading: false,
        done: true,
      }
      break
    case ADD_NOTE_CLEAN:
      state = initialState
      break
    case ADD_NOTE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default NoteAdd
